import { render } from "./BrutalNav.vue?vue&type=template&id=34cc4cb5"
import script from "./BrutalNav.vue?vue&type=script&lang=js"
export * from "./BrutalNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__